export default "__VITE_ASSET__D3j45Xku__"